<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11K7WeL/tc-custom/9780226301723.jpg?1733030438690" alt="This image is the cover for the book Freud's Couch, Scott's Buttocks, Brontë's Grave, Culture Trails"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Freud's Couch, Scott's Buttocks, Brontë's Grave, Culture Trails
      </h1>
      <p class="bookDescription body article font2">
        <p>The Victorian era was the high point of literary tourism. Writers such as Charles Dickens, George Eliot, and Sir Walter Scott became celebrities, and readers trekked far and wide for a glimpse of the places where their heroes wrote and thought, walked and talked. Even Shakespeare was roped in, as Victorian entrepreneurs transformed quiet Stratford-upon-Avon into a combination shrine and tourist trap.<br/><br/> Stratford continues to lure the tourists today, as do many other sites of literary pilgrimage throughout Britain. And our modern age could have no better guide to such places than Simon Goldhill. In <i>Freud's Couch, Scott’s Buttocks, Brontë's Grave</i>, Goldhill makes a pilgrimage to Sir Walter Scott's baronial mansion, Wordsworth's cottage in the Lake District, the Bront ë parsonage, Shakespeare's birthplace, and Freud's office in Hampstead. Traveling, as much as possible, by methods available to Victorians—and gamely negotiating distractions ranging from broken bicycles to a flock of giggling Japanese schoolgirls—he tries to discern what our forebears were looking for at these sites, as well as what they have to say to the modern mind. What does it matter that Emily Brontë’s hidden passions burned in this specific room? What does it mean, especially now that his fame has faded, that Scott self-consciously built an extravagant castle suitable for Ivanhoe—and star-struck tourists visited it while he was still living there? Or that Freud's meticulous recreation of his Vienna office is now a meticulously preserved museum of itself? Or that Shakespeare’s birthplace features student actors declaiming snippets of his plays . . . in the garden of a house where he almost certainly never wrote a single line?<br/><br/> Goldhill brings to these inquiries his trademark wry humor and a lifetime's engagement with literature. The result is a travel book like no other, a reminder that even today, the writing life still has the power to inspire.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Simon Goldhill
      </h2>
      
      <p class="authorDescription body article"><P><B>Simon Goldhill</B> is professor of Greek literature and culture and fellow and director of studies in classics at King's College, Cambridge, as well as director of the Cambridge Victorian studies group. He is the author of many books, including <I>Love, Sex, and Tragedy: How the Ancient World Shapes Our Lives</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?032a41b3